
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-accounting-service",
      function () {
        return require("private-next-pages/free-accounting-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-accounting-service"])
      });
    }
  